import React from "react";
import "./hero.css";
import { FaUser, FaSuitcase } from "react-icons/fa";
import TypedComponent from "../Typed/type";
import Buttons from "../Buttons";
import Navbar from "../Navbar/index";
import { motion } from "framer-motion";

const HeroSection = () => {
  const variants = {
    hidden: { opacity: 0, x: -1500, y: 0 },
    enter: { opacity: 1, x: 0, y: 0 },
    exit: { opacity: 1, x: 0, y: -200 },
  };
  return (
    <motion.div
      variants={variants}
      initial="hidden"
      animate="enter"
      exit="exit"
      transition={{ type: "linear", duration: 0.5 }}
    >
      <Navbar activeLi1={"activeLi"} />
      <section className="header_area" id="header_area">
        <div className="container">
          <div className="header_contents">
            <div className="header_contents_right">
              <div className="sm_title">
                <h4>HI THERE !</h4>
              </div>
              <div className="big_title">
                <h1>
                  I'M{" "}
                  <span className="typed">
                    <TypedComponent />
                  </span>
                </h1>
              </div>
              <div className="about_myselft">
                <p>
                  I'm a Front-End Developer based in Chittagong, Bangladesh. I
                  strives to build immersive and beautiful web applications
                  through carefully crafted code and user-centric design.
                </p>
              </div>
              <div className="section_btns">
                <Buttons
                  btnIcon={<FaUser />}
                  btntext={"more about me"}
                  href="/about"
                />
                <Buttons
                  btnIcon={<FaSuitcase />}
                  btntext={"Projects"}
                  href="/projects"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </motion.div>
  );
};

export default HeroSection;
